import Slick from 'react-slick';
import './slick.scss';
import './slick-theme.scss';

export default Slick;
